export const site = {
  name: 'Alex Cerezo',
  url: 'https://alexcerezo.com',
  description:
    'Product designer focused on solving real user problems and business needs through impactful digital products. Based in Spain.',
  email: 'hello.alexcerezo@gmail.com',
  linkedin: 'https://www.linkedin.com/in/alexcerezo/',
  resumeUrl:
    'https://www.dropbox.com/scl/fi/0kk13ctsil7xpftstswy0/AlexCerezo_Resume.pdf?rlkey=hcu988vxsrbncwb09himqwdwp&st=2feyayq7&dl=0',
  ogImage: '/assets/imgs/about/alex.webp',
  titles: {
    home: 'Alex Cerezo | Product Designer',
    about: 'Alex Cerezo | About',
    pastWork: 'Alex Cerezo | Past work',
    notFound: 'Alex Cerezo | Not found'
  }
};

export const pastWork = [
  { src: '/assets/imgs/past/past00.webp', alt: 'Past design work 01 — product UI sample' },
  { src: '/assets/imgs/past/past01.webp', alt: 'Past design work 02 — product UI sample' },
  { src: '/assets/imgs/past/past02.webp', alt: 'Past design work 03 — product UI sample' },
  { src: '/assets/imgs/past/past03.webp', alt: 'Past design work 04 — landing page sample' },
  { src: '/assets/imgs/past/past04.webp', alt: 'Past design work 05 — landing page sample' },
  { src: '/assets/imgs/past/past05.webp', alt: 'Past design work 06 — visual design sample' },
  { src: '/assets/imgs/past/past06.webp', alt: 'Past design work 07 — visual design sample' },
  { src: '/assets/imgs/past/past07.webp', alt: 'Past design work 08 — UI component sample' },
  { src: '/assets/imgs/past/past08.webp', alt: 'Past design work 09 — UI component sample' },
  { src: '/assets/imgs/past/past09.webp', alt: 'Past design work 10 — marketing layout sample' },
  { src: '/assets/imgs/past/past10.webp', alt: 'Past design work 11 — marketing layout sample' },
  { src: '/assets/imgs/past/past11.webp', alt: 'Past design work 12 — product screen sample' },
  { src: '/assets/imgs/past/past12.webp', alt: 'Past design work 13 — product screen sample' },
  { src: '/assets/imgs/past/past13.webp', alt: 'Past design work 14 — visual exploration' },
  { src: '/assets/imgs/past/past14.webp', alt: 'Past design work 15 — visual exploration' },
  { src: '/assets/imgs/past/past15.webp', alt: 'Past design work 16 — interface sample' },
  { src: '/assets/imgs/past/past16.webp', alt: 'Past design work 17 — interface sample' }
];
